import React, { useEffect, useState } from 'react';
import { MoreVertical } from 'lucide-react';
import { IconButton } from '../ui';
import useClickOutside from '../../hooks/useClickOutside';

const CalendarViewDropdown = ({ calendarRef }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useClickOutside(() => setIsOpen(false));
  const [activeView, setActiveView] = useState({ id: 'dayGridMonth', label: 'Month' });
  const views = [
    { id: 'timeGrid1Day', label: 'Day' },
    { id: 'timeGridThreeDay', label: '3 Days' },
    { id: 'listWeek', label: 'List' },
  ];
  const initialView = calendarRef.current ? calendarRef.current.getApi().view.type : 'dayGridMonth';

  useEffect(() => {
    const initial = views.find((view) => view.id === initialView) || {
      id: 'dayGridMonth',
      label: 'Month',
    };
    setActiveView(initial);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleViewChange = (viewId) => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.changeView(viewId);
      setIsOpen(false);
      setActiveView(views.find((view) => view.id === viewId));
    }
  };

  return (
    <div ref={dropdownRef} className='mobile-tour-calendar-change-view relative'>
      <IconButton
        icon={MoreVertical}
        onClick={() => setIsOpen(!isOpen)}
        variant='fillPrimary'
        tooltip='Change view'
        className='rounded-lg'
      />

      {isOpen && (
        <div
          className='absolute right-0 mt-2 w-48 rounded-lg z-[200] shadow-xl overflow-hidden'
          style={{
            background: 'var(--bg-card)',
            border: '1px solid var(--border)',
          }}
        >
          {views.map((view) => (
            <button
              key={view.id}
              type='button'
              onClick={() => handleViewChange(view.id)}
              className='w-full text-left px-4 py-2.5 text-sm transition-colors cursor-pointer'
              style={{
                background: activeView.id === view.id ? 'var(--bg-card-alt)' : 'transparent',
                color: activeView.id === view.id ? 'var(--brand)' : 'var(--text-body)',
                fontWeight: activeView.id === view.id ? 600 : 400,
              }}
              onMouseEnter={(e) => {
                if (activeView.id !== view.id) {
                  e.currentTarget.style.background = 'var(--bg-surface)';
                  e.currentTarget.style.color = 'var(--text-primary)';
                }
              }}
              onMouseLeave={(e) => {
                if (activeView.id !== view.id) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = 'var(--text-body)';
                }
              }}
            >
              {view.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CalendarViewDropdown;
